import { useEffect } from 'react';
import { initFilm } from '@/lib/film';
import { initPanels } from '@/lib/panels';
import { ToastProvider } from '@/components/wedding/ToastProvider';
import Nav from '@/components/wedding/Nav';
import Chapter from '@/components/wedding/Chapter';
import Manifesto from '@/components/wedding/Manifesto';
import CouplePanel from '@/components/wedding/CouplePanel';
import CeremonyPanel from '@/components/wedding/CeremonyPanel';
import GalleryPanel from '@/components/wedding/GalleryPanel';
import MapPanel from '@/components/wedding/MapPanel';
import AccountPanel from '@/components/wedding/AccountPanel';
import ExtraInfoSection from '@/components/wedding/ExtraInfoSection';
import RsvpSection from '@/components/wedding/RsvpSection';
import GuestbookSection from '@/components/wedding/GuestbookSection';
import ClosingSection from '@/components/wedding/ClosingSection';

export default function Home() {
  useEffect(() => {
    const cleanupFilm = initFilm();
    const cleanupPanels = initPanels();
    return () => {
      cleanupFilm();
      cleanupPanels();
    };
  }, []);

  return (
    <ToastProvider>
      <div className="relative w-full overflow-x-clip">
        <Nav />
        <main>
          <Chapter />
          <Manifesto />
          <CouplePanel />
          <CeremonyPanel />
          <GalleryPanel />
          <MapPanel />
          <AccountPanel />
          <ExtraInfoSection />
          <RsvpSection />
          <GuestbookSection />
        </main>
        <ClosingSection />
      </div>
    </ToastProvider>
  );
}